export default function initSelect(root, onChange = () => {}) {
  if (!root) return null;

  const trigger = root.querySelector('.js-ui-select-trigger');
  const current = root.querySelector('.js-ui-select-current');
  const menu = root.querySelector('.js-ui-select-menu');
  const options = [...root.querySelectorAll('.js-ui-select-option')];

  if (!trigger || !current || !menu || !options.length) return null;

  function setValue(value) {
    const selected = options.find((option) => option.dataset.value === String(value));
    if (!selected) return;

    current.textContent = selected.textContent.trim();
    options.forEach((option) => {
      const isSelected = option === selected;
      option.classList.toggle('ui-select__option--selected', isSelected);
      option.setAttribute('aria-selected', String(isSelected));
    });
  }

  function close() {
    menu.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  function open() {
    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    options.find((option) => option.getAttribute('aria-selected') === 'true')?.focus();
  }

  function choose(option) {
    setValue(option.dataset.value);
    onChange(option.dataset.value);
    close();
    trigger.focus();
  }

  trigger.addEventListener('click', () => {
    if (menu.hidden) open();
    else close();
  });

  trigger.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      open();
    } else if (event.key === 'Escape') {
      close();
    }
  });

  options.forEach((option, index) => {
    option.addEventListener('click', () => choose(option));
    option.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        trigger.focus();
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        choose(option);
      } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % options.length;
        if (event.key === 'ArrowUp') nextIndex = (index - 1 + options.length) % options.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = options.length - 1;
        options[nextIndex].focus();
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!root.contains(event.target)) close();
  });
  root.addEventListener('focusout', (event) => {
    if (!root.contains(event.relatedTarget)) close();
  });

  return { setValue };
}
